(function () {
  if (window.__ixsLoaded) return;
  window.__ixsLoaded = true;
  document.documentElement.classList.add('ixs-js');

  var fmtMoney = function (cents, fmt) {
    var n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return (fmt || 'S/ {{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  };

  /* Animación al hacer scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  var reveal = function (root) {
    (root || document).querySelectorAll('.ixs-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  };

  /* Clicks delegados */
  document.addEventListener('click', function (ev) {
    var t;
    if ((t = ev.target.closest('[data-ixs-tab]'))) {
      var cat = t.closest('[data-ixs-catalog]');
      var g = t.getAttribute('data-ixs-tab');
      cat.querySelectorAll('[data-ixs-tab]').forEach(function (b) { b.classList.toggle('is-on', b === t); });
      var n = 0;
      cat.querySelectorAll('[data-ixs-gen]').forEach(function (c) {
        var show = g === 'all' || c.getAttribute('data-ixs-gen') === g;
        c.style.display = show ? '' : 'none';
        if (show) n++;
      });
      var cnt = cat.querySelector('[data-ixs-count]');
      if (cnt) cnt.textContent = n + (n === 1 ? ' modelo' : ' modelos');
    }
    if ((t = ev.target.closest('[data-ixs-hero-color]'))) {
      var hero = t.closest('[data-ixs-hero]');
      hero.querySelectorAll('[data-ixs-recolor]').forEach(function (p) { p.style.setProperty('--c', t.getAttribute('data-hex')); });
      hero.querySelectorAll('[data-ixs-hero-color]').forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
      var lbl = hero.querySelector('[data-ixs-hero-label]');
      if (lbl) lbl.textContent = t.getAttribute('data-name');
    }
  });

  /* Página de producto */
  var initProduct = function (root) {
    if (!root || root.__ixs) return;
    root.__ixs = true;
    var data = JSON.parse(root.querySelector('[data-ixs-variants]').textContent);
    var moneyFmt = root.getAttribute('data-money') || 'S/ {{amount}}';
    var wa = root.getAttribute('data-wa');
    var title = root.getAttribute('data-title');
    var sel = [];
    var cur = data.find(function (v) { return v.id === Number(root.getAttribute('data-current')); }) || data[0];
    cur.options.forEach(function (o, i) { sel[i] = o; });

    var find = function () {
      return data.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    };
    var update = function () {
      var v = find();
      root.querySelectorAll('[data-ixs-opt]').forEach(function (b) {
        var i = Number(b.getAttribute('data-ixs-opt'));
        var on = b.getAttribute('data-value') === sel[i];
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var pr = b.querySelector('[data-ixs-optprice]');
        if (pr) {
          var test = sel.slice(); test[i] = b.getAttribute('data-value');
          var tv = data.find(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); });
          pr.textContent = tv ? (tv.available ? fmtMoney(tv.price, moneyFmt) : 'Agotado') : 'No disponible';
        }
      });
      root.querySelectorAll('[data-ixs-optlabel]').forEach(function (l) { l.textContent = sel[Number(l.getAttribute('data-ixs-optlabel'))] || ''; });
      var priceEl = root.querySelector('[data-ixs-price]');
      var sumEl = root.querySelector('[data-ixs-summary]');
      var btn = root.querySelector('[data-ixs-add]');
      var idEl = root.querySelector('[data-ixs-id]');
      var waEl = root.querySelector('[data-ixs-wa]');
      if (v) {
        priceEl.textContent = fmtMoney(v.price, moneyFmt);
        sumEl.textContent = v.title.split(' / ').join(' · ');
        idEl.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label') : 'Agotado';
        if (waEl && wa) waEl.href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent('Hola ISMORA, quiero comprar el ' + title + ' (' + v.title.split(' / ').join(', ') + ')');
        if (v.featured_media && v.featured_media.preview_image) {
          var img = root.querySelector('[data-ixs-main-img]');
          if (img) { img.src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; img.removeAttribute('srcset'); }
        }
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        }
      } else {
        priceEl.textContent = 'No disponible';
        btn.disabled = true;
        btn.textContent = 'No disponible';
      }
      var colorBtn = root.querySelector('[data-ixs-opt].ixs-swatch.is-on');
      if (colorBtn) root.querySelectorAll('[data-ixs-recolor]').forEach(function (p) { p.style.setProperty('--c', colorBtn.getAttribute('data-hex')); });
    };
    root.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-ixs-opt]');
      if (b) { sel[Number(b.getAttribute('data-ixs-opt'))] = b.getAttribute('data-value'); update(); }
      var th = ev.target.closest('[data-ixs-thumb]');
      if (th) {
        var img = root.querySelector('[data-ixs-main-img]');
        if (img) { img.src = th.getAttribute('data-ixs-thumb'); img.removeAttribute('srcset'); }
        root.querySelectorAll('[data-ixs-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === th); });
      }
    });
    update();
  };

  /* Formulario de cita */
  var initCita = function (root) {
    if (!root || root.__ixs) return;
    root.__ixs = true;
    var wa = root.getAttribute('data-wa');
    var go = function () {
      var lines = ['Hola ISMORA, quiero separar una cita.'];
      root.querySelectorAll('[data-ixs-field]').forEach(function (f) { if (f.value) lines.push(f.getAttribute('data-ixs-field') + ': ' + f.value); });
      var msg = lines.join('\n');
      root.querySelector('[data-ixs-cita-link]').href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(msg);
      var pv = root.querySelector('[data-ixs-cita-preview]');
      if (pv) pv.textContent = msg;
    };
    root.addEventListener('input', go);
    root.addEventListener('change', go);
    go();
  };

  var init = function (scope) {
    scope = scope || document;
    reveal(scope);
    scope.querySelectorAll('[data-ixs-product]').forEach(initProduct);
    scope.querySelectorAll('[data-ixs-cita]').forEach(initCita);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
